import React from 'react';
import ReactApexChart from 'react-apexcharts';

const DailyAIUsageChart = ({ dailyAiUsage = [] }) => {
  const dates = dailyAiUsage.map(item => {
    const date = new Date(item.Date);
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  });
  const apiCalls = dailyAiUsage.map(item => item.TotalAPICalls || 0);
  const tokens = dailyAiUsage.map(item => parseInt(item.TotalUsageInToken) || 0);

  const dailyAiUsageOptions = {
    chart: {
      type: 'line',
      toolbar: {
        show: true,
      },
    },
    stroke: {
      curve: 'smooth',
      width: 3,
    },
    xaxis: {
      categories: dates,
    },
    colors: ['#4CAF50', '#2196F3'],
    tooltip: {
      shared: true,
      intersect: false,
    },
  };

  const dailyAiUsageSeries = [
    {
      name: 'API Calls',
      type: 'line',
      data: apiCalls,
    },
    {
      name: 'Tokens Used',
      type: 'line',
      data: tokens,
    },
  ];

  return (
    <div className="col-xxl-6 col-xl-12">
      <div className="card h-100">
        <div className="card-body">
          <h6 className="text-lg mb-0" style={{ color: '#1B5E20', fontWeight: 'bold' }}>
            Daily AI Usage
          </h6>
          
          <ReactApexChart 
            options={dailyAiUsageOptions} 
            series={dailyAiUsageSeries} 
            type="line"
            height={300} 
          />
        </div>
      </div>
    </div>
  );
};

export default DailyAIUsageChart;